import { GlobalSettingEnum } from 'api/model';
import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';
import useGlobalSettings from './useGlobalSettings';

/** Tooltip på de avstängda skrivknapparna, så att det syns att knappen är låst och inte trasig. */
export const NO_ROUTE_PLAN_APPLY_ACCESS_TITLE =
  'Du har inte behörighet att verkställa i ruttplaneringen. Behörigheten sätts under Globala inställningar.';

/**
 * Får användaren SKRIVA i ruttplaneringen — verkställa paket och låsa uppdrag för manuell
 * planering?
 *
 * Egen lista (GlobalSettingEnum 106). Ruttplaneringen i sig syns för alla admins (märkt BETA) —
 * den som saknas i listan kan generera och granska förslag, men skrivknapparna är avstängda.
 *
 * Den här hooken styr bara vad som går att KLICKA på. Den riktiga spärren sitter i
 * RoutePlanningController (Apply och ReserveForManualPlanning), som prövar samma lista.
 */
const useHasAccessToRoutePlanApply = () => {
  const me = useMe();
  const { parsedData: globalSettings, loaded } = useGlobalSettings();

  return useMemo(() => {
    if (!me || !loaded) {
      return false;
    }

    // Tom lista = ingen får skriva. Funktionen ska slås på uttryckligen, inte råka vara på.
    return (
      globalSettings[GlobalSettingEnum.UsersWithAccessToRoutePlanApply][
        me.userID
      ] === true
    );
  }, [me, loaded, globalSettings]);
};

export default useHasAccessToRoutePlanApply;
